import { formatDateIT } from "@/lib/utils";

export default function DayTabs({ days, day, onSelect }) {
  return (
    <nav data-testid="day-tabs" className="print-hide flex overflow-x-auto border-b border-slate-300 bg-white sticky top-[52px] z-40 hide-scrollbar">
      {days.map((d) => (
        <button
          key={d.day}
          data-testid={`tab-day-${String(d.day).padStart(2, "0")}`}
          onClick={() => onSelect(d.day)}
          className={`px-3 py-2 text-sm font-semibold whitespace-nowrap border-r border-slate-200 transition-colors ${
            day === d.day
              ? "bg-slate-900 text-white"
              : "bg-white text-slate-700 hover:bg-slate-100 hover:text-slate-900"
          }`}
          title={`${d.weekday} ${formatDateIT(d.date_us)}`}
        >
          {String(d.day).padStart(2, "0")}
        </button>
      ))}
    </nav>
  );
}
